export abstract class AbstractStorageService<P> {
  protected constructor(private readonly storage: Storage) {
  }

  public read<T extends keyof P>(key: T): P[T] {
    try {
      const data = this.storage.getItem(key as string);

      if (data !== null) {
        return JSON.parse(data);
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  public write<T extends keyof P>(key: T, data: P[T]): void {
    this.storage.setItem(key as string, JSON.stringify(data));
  }

  public remove<T extends keyof P>(key: T): void {
    this.storage.removeItem(key as string);
  }

  public clear(): void {
    this.storage.clear();
  }
}
